import { ArchivePlusIcon } from './ArchivePlusIcon';

/**
 * author: Colton Wiscombe
 * id FA4EDA1A-8E9B-47EA-9436-B75CF8BB5B21
 * name archive-plus
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-plus.svg
 * tags
 */
export const ArchiveAddIcon = ArchivePlusIcon;
export default ArchiveAddIcon